import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
    providedIn: 'root'
})
export class IconsService {
    isIconsRegistered = false;
    iconsFolderPath = 'assets/img/icons/';
    icons = [
        'info',
        'arrow-down',
        'arrow-up',
        'arrow-left',
        'arrow-right',
        'close',
        'code',
        'target',
        'lock',
        'dots',
        'envelope',
        'search',
        'file',
        'files',
        'conversations',
        'visitors',
        'planning',
        'share',
        'ft-icn-file-ignore',
        'ft-icn-file-processed',
        'ft-icn-file-upload',
        'ft-icn-email',
        'error',
        'error-red',
        'external-link',
        'cloud-download',
        'touchpoint',
        'check',
        'checkmark-green',
        'checkmark-status',
        'checkmark-round',
        'party-popper',
        'calendar',
        'grade',
        'stat-clicks',
        'stat-leads',
        'stat-bookings',
        'stat-reach',
        'stat-visitors',
        'stat-photos',
        'stat-quotes',
        'stat-criticalfeedback',
        'plane',
        'icon_cards_social_facebook',
        'icon_cards_social_linkedin',
        'icon_cards_social_twitter',
        'ft-icn-flag',
        'icon-trophy',
        'ft-icn-seedplant',
        'icn-sun',
        'plus',
        'timestamp',
        'caption',
        'quote',
        'photo',
        'quotelist',
        'curate-inprogress',
        'curate-done',
        'icon_curate_done',
        'flipto-logo',
        'rating-stars0',
        'rating-stars1',
        'rating-stars2',
        'rating-stars3',
        'rating-grayscale-stars1',
        'rating-grayscale-stars2',
        'rating-grayscale-stars3',
        'rating-grayscale-stars4',
        'social-icon1',
        'social-icon2',
        'social-icon3',
        'lightbulb',
        'pegman',
        'arrow-open',
        'ft-icn-pencil-outline',
        'arrow-circle-down',
        'arrow-circle-up',
        'ft-icn-arrow-right',
        'ft-icn-arrow-down',
        'ft-emoji-icn-laptop',
        'ft-emoji-icn-waving-hand',
        'ft-emoji-icn-rocket',
        'ft-icn-stat-guestbooking',
        'ft-icn-stat-leads',
        'ft-icn-stat-reach',
        'ft-icn-stat-storytellers',
        'sort-by-date-asc',
        'sort-by-date-desc',
        'sort-by-quantity-asc',
        'sort-by-quantity-desc',
        'sort-by-text-asc',
        'sort-by-text-desc',
        'sort-by-time-asc',
        'sort-by-time-desc',
        'ft-icn-stat-storytellers',
        'range-start',
        'range-focus',
        'range-end',
        'menu',
        'star',
        'grid',
        'list',
        'bar-chart',
        'calendar-chart',
        'table',
        'flow-arrow',
        'geo',
        'line-chart',
        'radar-chart',
        'treemap',
        'treemap-alt',
        'zoom-in',
        'zoom-out',
        'expand',
        'icon-email',
        'icon-organic',
        'icon-paid',
        'icon-channel-organic',
        'icon-channel-paid',
        'icon-channel-messaging',
        'icon-channel-ai',
        'icon-channel-omnichannel',
        'icon-channel-internal',
        'attribution-first-touch',
        'attribution-last-touch',
        'attribution-linear',
        'attribution-positional',
        'attribution-time-decay',
        'hotel',
        'hotel-round',
        'histogram',
        'filter',
        'click',
        'peoples',
        'timeline',
        'desktop',
        'phone',
        'reload',
        'webpage',
        'milestone-group',
        'chart-toggle'
    ];


    constructor(private iconRegistry: MatIconRegistry, private sanitizer: DomSanitizer) {
    }

    register() {
        this.icons.forEach(icon => {
            this.iconRegistry.addSvgIcon(icon, this.sanitizer.bypassSecurityTrustResourceUrl(`${this.iconsFolderPath}${icon}.svg`));
        });
    }
}
